export default __webpack_public_path__ + "static/media/gursahi.cc443f0a.jpg";